const ADMIN_CLIENT_ID = 'X7xMQJdEw5S3mkVSv8ZKdGy1';
const ADMIN_CLIENT_SECRET = 'eSSKTHOweSI0n3bIOuLjXCzjzqwjHoPs';
const CTP_AUTH_URL = 'europe-west1.gcp';
const CTP_API_URL = 'https://api.europe-west1.gcp.commercetools.com';
const CTP_PROJECT_KEY = 'rsschool-final-task-stage2';

export { ADMIN_CLIENT_ID, ADMIN_CLIENT_SECRET, CTP_AUTH_URL, CTP_API_URL, CTP_PROJECT_KEY };
